module.exports = __webpack_public_path__ + "img/abc.ed915131.jpg";